
import EmptyApiResponse from "../../api/dtos/EmptyApiResponse";
import ErrorCode from "../../api/dtos/ErrorCode";
import { MessagesViewModel } from "../../components/bases/Messages";

export interface PageState {
	ErrorCode: ErrorCode | string,
	MessageCall: null | ((message: MessagesViewModel) => void),
	MessageDuration: number,
	IsLoading: boolean,
	LoadingCount: number,
}

export const HANDLE_ERROR = 'HANDLE_ERROR';
export const HANDLE_SUCCESS = 'HANDLE_SUCCESS';
export const SHOW_INFO_MESSAGE = 'SHOW_INFO_MESSAGE';
export const SHOW_ERROR_MESSAGE = 'SHOW_ERROR_MESSAGE';
export const HIDE_ALL_MESSAGES = 'HIDE_ALL_MESSAGES';
export const RESET_ERROR = 'RESET_ERROR';
export const RESET_MESSAGE = 'RESET_MESSAGE';
export const PAGE_START_LOADING = 'PAGE_START_LOADING';
export const PAGE_END_LOADING = 'PAGE_END_LOADING';


interface HandleErrorAction {
	type: typeof HANDLE_ERROR,
	response: EmptyApiResponse
}

interface HandleSuccessAction {
	type: typeof HANDLE_SUCCESS,
	duration: number,
	message: string,
}

interface ShowInfoMessageAction {
	type: typeof SHOW_INFO_MESSAGE,
	duration: number,
	message: string,
}

interface ShowErrorMessageAction {
	type: typeof SHOW_ERROR_MESSAGE,
	duration: number,
	message: string,
}

interface HideAllMessagesAction {
	type: typeof HIDE_ALL_MESSAGES,
}

interface ResetErrorAction {
	type: typeof RESET_ERROR,
}

interface ResetMessageAction {
	type: typeof RESET_MESSAGE
}

interface LoadingStartAction {
	type: typeof PAGE_START_LOADING
}

interface LoadingEndAction {
	type: typeof PAGE_END_LOADING
}


export type PageActionTypes =
	HandleErrorAction |
	ResetErrorAction |
	HandleSuccessAction |
	ShowInfoMessageAction |
	ShowErrorMessageAction |
	HideAllMessagesAction |
	ResetMessageAction |
	LoadingStartAction |
	LoadingEndAction;
